<template>
  <!-- eslint-disable vue/no-unused-vars -->
  <div class="view-container text-center">
    <div class="text-right cursor-pointer">
      <b-button
        variant="link"
        @click="back"
      >
        <font-awesome-icon icon="times" />
      </b-button>
    </div>

    <h1>Accertamento dati anagrafici, redditi e patrimonio</h1>

    <loading-spinner v-if="loading" />
    <div
      v-else-if="$store.getters.isAuthenticated"
      class="row justify-content-between mx-2 mt-5 mb-2 align-middle"
    >
      <h4>Elenco documenti</h4>
      <div class="text-right">
        <b-button
          v-if="false === true"
          variant="primary"
          @click="onNewDocumentClick"
        >
          <font-awesome-icon
            icon="plus"
            class="mr-2"
          />Aggiungi documento
        </b-button>
      </div>
    </div>

    <b-alert
      v-if="!loading && !items.length"
      show
      variant="info"
      class="my-4"
    >
      Non ci sono precedenti dichiarazioni in archivio. 
      <!-- <div>Premere il tasto "<a
        href="#"
        class="alert-link"
        @click="onNewDocumentClick"
      >Aggiungi documento</a>" per inserirne una nuova.</div> -->
      
    </b-alert>

    <b-table
      v-else-if="items.length"
      striped
      bordered
      hover
      :fields="fields"
      :items="items"
      :responsive="true"
      :busy="false"
      @row-clicked="onRowClicked"
    >

      <template v-slot:head(icon)>
        <font-awesome-icon
          icon="file-alt"
          size="lg"
          class="text-muted"
        />
      </template>

      <template v-slot:cell(icon)="data">
        <!-- Clonabile "{{data.item.clonable}}"
        Editabile "{{data.item.editable}}" -->
        <!-- <font-awesome-icon
          v-if="data.item.stato === 'B'"
          icon="pen"
          size="lg"
          class="text-primary cursor-pointer"
        /> -->
        <font-awesome-icon
          v-if="isEditable(data.item, 'plus')"
          icon="plus"
          size="lg"
          class="text-info cursor-pointer"
        />
        <font-awesome-icon
          v-else-if="isEditable(data.item, 'search') && data.item.stato !== 'K'"
          icon="search"
          size="lg"
          class="text-success cursor-pointer"
        />
        <font-awesome-icon
          v-else-if="isEditable(data.item, 'pen')"
          icon="pen"
          size="lg"
          class="text-primary cursor-pointer"
        />
        <font-awesome-icon
          v-else-if="data.item.stato !== 'K'"
          icon="search"
          size="lg"
          class="text-success cursor-pointer"
        />
      </template>

      <template v-slot:cell(descrizioneStato)="data">
        <!-- <span class="font-weight-bold text-uppercase"
          :class="{'text-primary':data.item.stato==='A','text-success':data.item.stato==='C'}"
        > -->
        <span
          class="font-weight-bold text-uppercase"
          :class="{
            'text-primary': data.item.stato === 'B',
            'text-info': data.item.stato === 'P',
            'text-warning': data.item.stato === 'C', 
            'text-success': data.item.stato === 'V'
          }"
        >
          {{ data.value }}
        </span>
      </template>

      <template v-slot:cell(download)="data">

        <!-- <b-form-select v-model="data.item.downloadItem" :options="fileDownloadOptions" size="sm" v-if="data.item.stato === 'V'" /> -->

        <template v-if="data.item.stato === 'V'">

          <b-dropdown variant="outline"
            v-if="data.item.downloadableDocuments.length > 1"
            title="Seleziona documento da scaricare"
          >
            <template slot="button-content">
              <font-awesome-icon icon="file-alt" class="text-success cursor-pointer" size="lg"/>
            </template>
              <b-dropdown-item
                v-for="(document,idx) in data.item.downloadableDocuments"
                :key="idx"
                >
                <a
                  target="_blank"
                  :href="urlDichiarazione({id: document.id, tipo: document.tipo, idDich: data.item.id, redditi: data.item})"
                  @click.stop
                  v-b-tooltip.hover
                  :title="document.tipo"
                  >
                    {{document.filename ? document.filename : data.item.filename}}
                </a>
                </b-dropdown-item>
          </b-dropdown>

          <a v-else
            :href="urlDichiarazione({id: data.item.id, tipo: 'dichiarazione'})"
            target="_blank"
            @click.stop
            v-b-tooltip.hover
            title="Scarica il documento"
          >
            <font-awesome-icon
              v-if="data.item.mimeType"
              icon="file-alt"
              size="lg"
              class="text-success cursor-pointer"
            />
          </a>

        </template>

      </template>

      <!-- <template v-slot:cell(+)="data">
        {{data.item.clonable}}
        <a
          xxxhref="doCloneDich(data.item.id)"
          target="_blank"
          @click.stop
          v-b-tooltip.hover
          title="Nuova dichiarazione"
          v-if="data.item.clonable !== 'NO'"
        >
          <font-awesome-icon
            icon="plus"
            size="lg"
            class="text-success cursor-pointer"
          />
        </a>
      </template> -->

    </b-table>
    <div class="row justify-content-between mx-0 mt-0 mb-2 align-middle">
      <div class="text-right">
        <b-pagination
          :total-rows="totalRows"
          :per-page="perPage"
          v-model="currentPage"
          class="my-0"
        />
      </div>
      <div class="text-right">
        <b-form-group
          description="Per pagina"
          class="mb-0"
        >
          <b-form-select
            :options="pageOptions"
            v-model="perPage"
          />
        </b-form-group>
      </div>
    </div>
    <nuova-dichiarazione-modal ref="modal" />
  </div>
</template>

<script>
import moment from 'moment'
import LoadingSpinner from '@/components/LoadingSpinner'
import NuovaDichiarazioneModal from '@/components/NuovaDichiarazioneModal'

export default {
  components: {
    LoadingSpinner,
    NuovaDichiarazioneModal

  },
  data () {
    return {
      fields: [
        'icon',
        { key: 'anno', label: 'Anno' },
        { key: 'codiceUib', label: 'Codice BU' },
        { key: 'indirizzo', label: 'Indirizzo' },
        { key: 'descrizioneStato', label: 'Stato' },
        { key: 'tsUltimaModifica', label: 'Ultima modifica', formatter: (value) => { return value ? moment(value).format('DD-MM-YYYY HH:mm:ss') : '' } },
        { key: 'numeroProtocollo', label: 'Protocollo' },
        'download'
        // '+'
      ],
      loading: true,
      items: [],
      currentPage: 1,
      perPage: 5,
      totalRows: 0,
      pageOptions: [5, 10, 15],
      downloadItem: '',
      fileDownloadOptions: [
        { text: 'primo', url: '' },
        { text: 'secondo', url: '' },
        { text: 'terzo', url: '' }
      ]
    }
  },

  async created () {
    await this.load()
  },

  methods: {

    back () {
      this.$router.push({ name: 'home' })
    },

    async load () {
      try {
        this.loading = true
        await this.$store.dispatch('dichiarazioni/loadItems')
        this.items = this.$store.state.dichiarazioni.items
        // console.log('Dichiarazioni caricate: ', this.items)
      } catch (err) {
        // console.log('Errore in load Lista dichiarazioni')
        this.$ui.showError(err)
        // Se c'è qualsiasi tipo di problema nel caricamento della lista delle dichiarazioni esce comunque.
        this.$router.push({ name: 'home' })
      }
      this.loading = false
    },

    async onNewDocumentClick () {
      await this.$refs.modal.open()
    },

    onRowClicked (row) {
      // Aggiunta verifica extra per sicurezza
      // Verifica se lo stato è 'K' (CENSIMENTO GIA' PRESENTE SUL SISTEMA)
      if (row.stato === 'K') {
        return
      }
      this.$router.push({ name: 'dichiarazione', params: { id: row.id, clonable: row.clonable } })
    },

    urlDichiarazione (toDownload) {
      let retUrn = ''
      // console.log('toDownload', toDownload.redditi)
      if (toDownload.tipo === 'dichiarazione') {
        retUrn = `/api/dichiarazioni/${toDownload.id}/download`
      } else {
        retUrn = `/api/dichiarazioni/${toDownload.id}/attachment/${toDownload.idDich}`
      }
      return retUrn
    },

    isEditable (currentRow, idScope) {
      let retValue = false
      const anniConsentiti = this.$store.getters['options/getAnniConsentiti']
      const annoNonConsentito = !anniConsentiti.includes(currentRow.anno.toString())

      if (idScope === 'search') {
        // Mostra lente per documenti non modificabili o di anni non consentiti
        retValue = currentRow.editable !== null || annoNonConsentito
      } else if (idScope === 'plus') {
        // Mostra plus solo per documenti PRECOMPILATA (P) o CONFERMATA (V)
        // e se non esiste una bozza o documento da confermare per lo stesso anno
        // e solo per gli anni consentiti
        retValue = currentRow.clonable !== 'NO' && 
                  (currentRow.stato === 'P' || currentRow.stato === 'V') &&
                  !annoNonConsentito
      } else {
        // Mostra matita per documenti BOZZA (B) o IN ATTESA DI FIRMA (C)
        // solo per gli anni consentiti
        retValue = ((retValue = (currentRow.stato === 'P' || currentRow.stato === 'C') && currentRow.editable !== 'NO')
                  || (currentRow.stato === 'B' ))
                  && !annoNonConsentito
      }
      return retValue
    }
  }
}
</script>
